import { ProcessingType } from './useProcessingState';

export interface AiCreationProgress {
  value: number;
  message: string;
}

export interface ProcCreationData {
  procId: string;
  progress: AiCreationProgress;

  isError?: boolean;
  error?: string;
  errorType?: string;
  errorCode?: number;
  errorDetails?: string;
  message?: string;
  timestamp?: number;
}

export enum ProcProcessingEventType {
  START = 'ai_proc_processing_start',
  GENERATING = 'ai_proc_processing_generating',
  RUN_END = 'ai_proc_processing_run_end',
}

export type ProcProcessingState = Pick<ProcCreationData, 'progress'> &
  Partial<Pick<ProcCreationData, 'isError' | 'error'>> & {
    prompt: string;
    type: ProcessingType.PROC_PROCESSING;
  };
